import LegalPage from "./LegalPage";

export default function RefundsPage() {
  return (
    <LegalPage
      eyebrow="Legal · The Philosopher Test"
      title="Refund Policy"
      updated="July 20, 2026"
      testid="refunds-screen"
      path="/refunds"
      metaDescription="14-day no-questions-asked refund policy for The Philosopher Test Full Report. Email us to request a refund."
    >
      <h2>Summary</h2>
      <p>
        The Full Report is a digital product delivered instantly at the moment of purchase. If
        you are unhappy with your report you can request a full refund within{" "}
        <strong>14&nbsp;days</strong> of the purchase — no questions asked. Just email us.
      </p>

      <h2>How to request a refund</h2>
      <ol>
        <li>
          Write to{" "}
          <a href="mailto:contact@thephilosophertest.com">contact@thephilosophertest.com</a>{" "}
          within 14 days of your purchase.
        </li>
        <li>
          Include the email you used at checkout (this helps us find the Stripe transaction).
          Sharing your result ID (visible in your report URL, e.g.{" "}
          <code>/report/abc123def456</code>) will speed things up.
        </li>
      </ol>
      <p>
        We aim to reply within 2 business days and process the refund to your original payment
        method. Depending on your bank, the refunded amount typically appears in 5–10 business
        days.
      </p>

      <h2>What happens to your report after a refund?</h2>
      <p>
        We revoke access to the private report link and delete the generated report content from
        our database. If you would like, we can also delete the underlying quiz results — say so
        in your email.
      </p>

      <h2>Consumer rights (EU/UK)</h2>
      <p>
        For customers in the EU / UK: the Full Report is a digital content product delivered
        immediately upon payment. By starting the purchase, you agree that the 14-day statutory
        withdrawal period may not apply once the content has been generated and delivered.
        Nevertheless, our voluntary 14-day refund policy above always applies.
      </p>

      <h2>Payment disputes</h2>
      <p>
        Please reach out to us first at{" "}
        <a href="mailto:contact@thephilosophertest.com">contact@thephilosophertest.com</a> before
        initiating a chargeback — we will almost always resolve it faster and more fairly. Formal
        chargeback rights remain unaffected.
      </p>
    </LegalPage>
  );
}
